export class SliderParameters {
  min: number = 0;
  max: number = 100;
  step: number = 1;

  minSelectable: number;
  maxSelectable: number;
  minText: string;
  maxText: string;
}
